import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum IndividualComplianceSecurityRight {
    CanAccess = 5000,
    ManageCompliance = 5001,
    ManageComplianceRules = 5002
}

export class IndividualComplianceSecurityModule extends BaseSecurityModule<IndividualComplianceSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.IndividualCompliance,
            [
                { _id: IndividualComplianceSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: IndividualComplianceSecurityRight.ManageCompliance, name: 'Manage Compliance', basic: true },
                { _id: IndividualComplianceSecurityRight.ManageComplianceRules, name: 'Manage Compliance Rules', basic: false },
            ] as SecurityRight<IndividualComplianceSecurityRight>[]
        );

        this.plan = TenantSubscription.Professional;
    }


}
